import { CoveoSearchEngineService } from "../service/coveo-engine.service";
import { CoveoTokenService } from "../service/coveo-token.service";

export const coveoConfig = {
	accessToken: "xxa138d127-0908-40c1-9e22-198f67b1489a",
	defaultSearchBoxId: "headerSearchBox",
	defaultSearchInterfaceId: "headerSearch",
	locale: "en-US",
	orgId: "texasinstrumentsof16fcd3",
	redirectUrl: "//{0}/sitesearch/{1}/docs/universalsearch.tsp?langPref={2}",
	searchHub: "universalsearch_en",
	tokenUrl: "/search/coveo/newToken"
}

export default async () => {
	/**
	 * The code to be executed should be placed within a default function that is
	 * exported by the global script. Ensure all of the code in the global script
	 * is wrapped in the function() that is exported.
	 */
	const win = (window ?? {}) as any;
	win.com ??= {};
	win.com.TI ??= {};
	win.com.TI.search ??= {};
	win.com.TI.search.coveoTokenService ??= CoveoTokenService;
	win.com.TI.search.coveoSearchEngineService ??= CoveoSearchEngineService;
};
